import { render, staticRenderFns } from "./Angkasa.vue?vue&type=template&id=61441fe5"
import script from "./Angkasa.vue?vue&type=script&lang=js"
export * from "./Angkasa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports